import React, { useEffect, useState } from 'react'
import { useRecoilState, useRecoilValue } from 'recoil'
import checkbox from 'src/assets/common/join/checkbox.png'

import checkbox_active from '@/assets/common/join/active_checkbox.png'
import { RefundTermYN } from '@/features/support/refund/store'
import Modal from '@/shared/components/common/Modal/Modal'
import { TYPE_REFUND_TERMS } from '@/shared/constant/cmdtype'
import { useGetTermsQueryData } from '@/shared/hooks/reactquery'
import { useModal } from '@/shared/hooks/useModal'
import { TelTypeState } from '@/shared/store'
import { captureRefundTermsError } from '@/shared/utils/sentry/validation'
import * as S from '@/styles/views/Support/refund'

const CHECKBOX_ID = 'refund-agree-checkbox'

const RefundTerms = () => {
  const [modalOption, setModalOption] = useState({ title: '', content: '' })
  const { data: TermsQueryData } = useGetTermsQueryData(TYPE_REFUND_TERMS)
  const { isOpen, toggle } = useModal()
  const [termsAgree, setTermsAgree] = useRecoilState(RefundTermYN)
  const TelType = useRecoilValue(TelTypeState)
  const isSkt = TelType === 0

  useEffect(() => {
    setTermsAgree(false)
  }, [TelType, setTermsAgree])

  const TermsModalOpen = (title: string, content: string) => {
    setModalOption({ title, content })
    toggle()
  }

  const openTermsModal = () => {
    const body = TermsQueryData?.Body?.[0]
    captureRefundTermsError(TermsQueryData?.Body)

    if (!body?.LgupTitle || !body?.LgupTerms) return
    TermsModalOpen(body.LgupTitle, body.LgupTerms)
  }

  return (
    <S.RefundTerms>
      <S.RefundTermCheckboxLabel active={termsAgree} htmlFor={CHECKBOX_ID}>
        <input
          id={CHECKBOX_ID}
          type="checkbox"
          checked={termsAgree}
          onChange={() => setTermsAgree(!termsAgree)}
        />
        <img src={termsAgree ? checkbox_active : checkbox} alt="약관 동의" />
      </S.RefundTermCheckboxLabel>

      <S.RefundTermContent>
        <S.RefundTermDetailButton type="button" onClick={openTermsModal}>
          개인정보 수집 및 이용동의(필수)
        </S.RefundTermDetailButton>
        {isSkt && (
          <S.RefundTermSuffixLabel htmlFor={CHECKBOX_ID}>
            에 동의하며 아래 내용을 모두 확인했습니다.
          </S.RefundTermSuffixLabel>
        )}
      </S.RefundTermContent>

      <Modal isOpen={isOpen} type="terms" option={modalOption} ClickFunc={() => toggle()} />
    </S.RefundTerms>
  )
}
export default RefundTerms
